module.exports = __webpack_public_path__ + "assets/img/yutariya-photo01.bf547f3e.jpg";